import {LoadableFilter} from "@/lib/store/state/filters/LoadableFilter";
import {Vehicle} from "@/services/store/modules/vehicles/Vehicle";

export class VehicleFilter extends LoadableFilter<Vehicle> {
    public displayFieldName: keyof Vehicle = "legalName";
    public defaultValue: string = null;
    public defaultText: string = "Choose Vehicle";
}
